import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import { PAGEINDEX } from "@/enum/global";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    component: Home,
    children: [
      {
        path: "/ui",
        name: "Ui",
        component: () => import("../views/Ui.vue")
      },
      // {
      //     path: "/",
      //     name: "Index",
      //     component: () =>
      //         import ("../views/Index.vue"),
      // },
      {
        path: "/",
        name: "Main",
        redirect: "/exporthistory",
        component: () => import("../views/Main.vue"),
        children: [
          {
            path: "createnew",
            name: PAGEINDEX.CREATE,
            component: () => import("../views/CreateNew.vue")
          },
          {
            path: "exporthistory",
            name: PAGEINDEX.EXPORTHISTORY,

            component: () => import("../views/ExportHistory.vue")
          },
          {
            path: "download",
            name: PAGEINDEX.DOWNLOAD,
            component: () => import("../views/Download.vue")
          },
          {
            path: "exporthistory/:id",
            name: PAGEINDEX.EXPORTHISTORYDETAIL,
            component: () => import("../views/ExportHistoryDetail.vue")
          }
        ]
      },
      {
        path: "/faq",
        name: "FAQ",
        component: () => import("../views/FAQ.vue")
      },
      {
        path: "/documentation",
        name: "Documentation",
        component: () => import("../views/Documentation.vue")
      },
      {
        path: "*",
        redirect: "/exporthistory"
      }
    ]
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
